import { IRiskIndicatory } from 'APIPackage/DictionariesModule/interfaces/IRiskIndicatory';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryRiskIndicatorySelectOptionForDecision = makeCreateDictionarySelectOption<IRiskIndicatory>(
  'id',
  'shortTitle',
);
